import _toConsumableArray from "/Users/francesco/Dropbox/Mac/Documents/GitHub/DFN-GRP-Web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/Users/francesco/Dropbox/Mac/Documents/GitHub/DFN-GRP-Web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { findToast, getToastPosition } from "./chunk-5XWPESX6.mjs";
import { getToastPlacement } from "./chunk-F6QD4NSP.mjs";

// src/toast.tsx
import { Alert, AlertDescription, AlertIcon, AlertTitle } from "@chakra-ui/alert";
import { chakra } from "@chakra-ui/system";
import { CloseButton } from "@chakra-ui/close-button";
import { runIfFn } from "@chakra-ui/shared-utils";

// src/toast.store.ts
var initialState = {
  top: [],
  "top-left": [],
  "top-right": [],
  "bottom-left": [],
  bottom: [],
  "bottom-right": []
};
var toastStore = createStore(initialState);
function createStore(initialState2) {
  var state = initialState2;
  var listeners = /* @__PURE__ */new Set();
  var setState = function setState(setStateFn) {
    state = setStateFn(state);
    listeners.forEach(function (l) {
      return l();
    });
  };
  return {
    getState: function getState() {
      return state;
    },
    subscribe: function subscribe(listener) {
      listeners.add(listener);
      return function () {
        setState(function () {
          return initialState2;
        });
        listeners.delete(listener);
      };
    },
    removeToast: function removeToast(id, position) {
      setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, position, prevState[position].filter(function (toast) {
          return toast.id != id;
        })));
      });
    },
    notify: function notify(message, options) {
      var toast = createToast(message, options);
      var position = toast.position,
        id = toast.id;
      setState(function (prevToasts) {
        var _a, _b;
        var isTop = position.includes("top");
        var toasts = isTop ? [toast].concat(_toConsumableArray((_a = prevToasts[position]) != null ? _a : [])) : [].concat(_toConsumableArray((_b = prevToasts[position]) != null ? _b : []), [toast]);
        return _objectSpread(_objectSpread({}, prevToasts), {}, _defineProperty({}, position, toasts));
      });
      return id;
    },
    update: function update(id, options) {
      if (!id) return;
      setState(function (prevState) {
        var nextState = _objectSpread({}, prevState);
        var _findToast = findToast(nextState, id),
          position = _findToast.position,
          index = _findToast.index;
        if (position && index !== -1) {
          nextState[position][index] = _objectSpread(_objectSpread(_objectSpread({}, nextState[position][index]), options), {}, {
            message: createRenderToast(options)
          });
        }
        return nextState;
      });
    },
    closeAll: function closeAll() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        positions = _ref.positions;
      setState(function (prev) {
        var allPositions = ["bottom", "bottom-right", "bottom-left", "top", "top-left", "top-right"];
        var positionsToClose = positions != null ? positions : allPositions;
        return positionsToClose.reduce(function (acc, position) {
          acc[position] = prev[position].map(function (toast) {
            return _objectSpread(_objectSpread({}, toast), {}, {
              requestClose: true
            });
          });
          return acc;
        }, _objectSpread({}, prev));
      });
    },
    close: function close(id) {
      setState(function (prevState) {
        var position = getToastPosition(prevState, id);
        if (!position) return prevState;
        return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, position, prevState[position].map(function (toast) {
          if (toast.id == id) {
            return _objectSpread(_objectSpread({}, toast), {}, {
              requestClose: true
            });
          }
          return toast;
        })));
      });
    },
    isActive: function isActive(id) {
      return Boolean(findToast(toastStore.getState(), id).position);
    }
  };
}
var counter = 0;
function createToast(message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _a, _b;
  counter += 1;
  var id = (_a = options.id) != null ? _a : counter;
  var position = (_b = options.position) != null ? _b : "bottom";
  return {
    id: id,
    message: message,
    position: position,
    duration: options.duration,
    onCloseComplete: options.onCloseComplete,
    onRequestRemove: function onRequestRemove() {
      return toastStore.removeToast(String(id), position);
    },
    status: options.status,
    requestClose: false,
    containerStyle: options.containerStyle
  };
}

// src/toast.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Toast = function Toast(props) {
  var status = props.status,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? "solid" : _props$variant,
    id = props.id,
    title = props.title,
    isClosable = props.isClosable,
    onClose = props.onClose,
    description = props.description,
    icon = props.icon;
  var ids = id ? {
    root: "toast-".concat(id),
    title: "toast-".concat(id, "-title"),
    description: "toast-".concat(id, "-description")
  } : void 0;
  return /* @__PURE__ */jsxs(Alert, {
    addRole: false,
    status: status,
    variant: variant,
    id: ids == null ? void 0 : ids.root,
    alignItems: "start",
    borderRadius: "md",
    boxShadow: "lg",
    paddingEnd: 8,
    textAlign: "start",
    width: "auto",
    children: [/* @__PURE__ */jsx(AlertIcon, {
      children: icon
    }), /* @__PURE__ */jsxs(chakra.div, {
      flex: "1",
      maxWidth: "100%",
      children: [title && /* @__PURE__ */jsx(AlertTitle, {
        id: ids == null ? void 0 : ids.title,
        children: title
      }), description && /* @__PURE__ */jsx(AlertDescription, {
        id: ids == null ? void 0 : ids.description,
        display: "block",
        children: description
      })]
    }), isClosable && /* @__PURE__ */jsx(CloseButton, {
      size: "sm",
      onClick: onClose,
      position: "absolute",
      insetEnd: 1,
      top: 1
    })]
  });
};
function createRenderToast() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var render = options.render,
    _options$toastCompone = options.toastComponent,
    ToastComponent = _options$toastCompone === void 0 ? Toast : _options$toastCompone;
  var renderToast = function renderToast(props) {
    if (typeof render === "function") {
      return render(_objectSpread(_objectSpread({}, props), options));
    }
    return /* @__PURE__ */jsx(ToastComponent, _objectSpread(_objectSpread({}, props), options));
  };
  return renderToast;
}
function createToastFn(dir, defaultOptions) {
  var normalizeToastOptions = function normalizeToastOptions(options) {
    var _a;
    return _objectSpread(_objectSpread(_objectSpread({}, defaultOptions), options), {}, {
      position: getToastPlacement((_a = options == null ? void 0 : options.position) != null ? _a : defaultOptions == null ? void 0 : defaultOptions.position, dir)
    });
  };
  var toast = function toast(options) {
    var normalizedToastOptions = normalizeToastOptions(options);
    var Message = createRenderToast(normalizedToastOptions);
    return toastStore.notify(Message, normalizedToastOptions);
  };
  toast.update = function (id, options) {
    toastStore.update(id, normalizeToastOptions(options));
  };
  toast.promise = function (promise, options) {
    var id = toast(_objectSpread(_objectSpread({}, options.loading), {}, {
      status: "loading",
      duration: null
    }));
    promise.then(function (data) {
      return toast.update(id, _objectSpread({
        status: "success",
        duration: 5e3
      }, runIfFn(options.success, data)));
    }).catch(function (error) {
      return toast.update(id, _objectSpread({
        status: "error",
        duration: 5e3
      }, runIfFn(options.error, error)));
    });
  };
  toast.closeAll = toastStore.closeAll;
  toast.close = toastStore.close;
  toast.isActive = toastStore.isActive;
  return toast;
}
export { Toast, createRenderToast, createToastFn, toastStore };